import React, { useEffect, useRef, useState } from "react";

export interface DropdownItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  danger?: boolean;
  divider?: boolean;
}

interface DropdownMenuProps {
  trigger: React.ReactNode;
  items: DropdownItem[];
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ trigger, items }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="ds-dropdown" ref={ref}>
      <button
        type="button"
        className="ds-icon-btn"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        aria-label="Mais ações"
      >
        {trigger}
      </button>
      {open && (
        <div className="ds-dropdown-menu" onClick={(e) => e.stopPropagation()}>
          {items.map((item, i) =>
            item.divider ? (
              <div className="ds-dropdown-divider" key={i} />
            ) : (
              <button
                key={i}
                type="button"
                className={`ds-dropdown-item ${item.danger ? "danger" : ""}`}
                onClick={() => {
                  setOpen(false);
                  item.onClick();
                }}
              >
                {item.icon}
                {item.label}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
